import { ReactNode } from 'react';
import styled from 'styled-components';
import {
    border,
    BorderProps,
    flexbox,
    FlexboxProps,
    layout,
    LayoutProps,
    position,
    PositionProps,
    shadow,
    ShadowProps,
    space,
    SpaceProps,
} from 'styled-system';
import { gap, GapProps } from '../utils/styled-components/gap';
import { color, ColorProps } from '../utils/styled-components/styledSystem';

export type InlineFlexBoxProps = React.HTMLAttributes<HTMLSpanElement> &
    SpaceProps &
    LayoutProps &
    FlexboxProps &
    BorderProps &
    PositionProps &
    ShadowProps &
    ColorProps &
    GapProps & {
        children?: ReactNode | ReactNode[];
    };

export const InlineFlexBox = styled.span<InlineFlexBoxProps>`
    box-sizing: border-box;
    ${space}
    ${layout}
    ${flexbox}
    ${border}
    ${position}
    ${shadow}
    ${color}
    ${gap}
`;

InlineFlexBox.defaultProps = {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
};

InlineFlexBox.displayName = 'InlineFlexBox';
